import { useState } from 'react';
import api from '../api';
import { LEGAL_VERSION } from '../constants/legalContent';
import './Dashboard.css';
import './Setup.css';

function Signup({ onSignedUp, onBackToLogin }) {
  const [form, setForm] = useState({
    name: '', email: '', password: '', company_name: '', phone: '', gstin: '',
  });
  const [acceptedLegal, setAcceptedLegal] = useState(false);
  const [error, setError] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const updateField = (field, value) => setForm((prev) => ({ ...prev, [field]: value }));

  const handleSubmit = (e) => {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    api
      .post('/auth/signup', {
        name: form.name,
        email: form.email,
        password: form.password,
        company_name: form.company_name,
        phone: form.phone || null,
        gstin: form.gstin || null,
        // The server rejects a signup without this, so the checkbox is a
        // convenience rather than the control.
        accepted_legal: acceptedLegal,
        accepted_legal_version: LEGAL_VERSION,
      })
      .then((res) => onSignedUp(res.data.email))
      .catch((err) => setError(err.response?.data?.detail || 'Could not create account'))
      .finally(() => setSubmitting(false));
  };

  return (
    <div className="setup-page">
      <div className="setup-card">
        <div className="setup-brand">
          KROSI<span>FIN</span>
        </div>
        <div className="setup-brand-sub">by NeedCFO</div>
        <h1 className="setup-title">Create your account</h1>
        <p className="setup-subtitle">Set up your own compliance tracker in a couple of minutes</p>
        <p style={{ color: '#059669', fontSize: 13, fontWeight: 600, marginTop: -4 }}>
          Free 15-day trial — full access, no card required.
        </p>

        {error && <p className="dash-error">{error}</p>}

        <form onSubmit={handleSubmit}>
          <div className="field-group">
            <span className="field-label">Your Name</span>
            <input
              className="field-input"
              required
              autoFocus
              value={form.name}
              onChange={(e) => updateField('name', e.target.value)}
            />
          </div>

          <div className="field-group">
            <span className="field-label">Email</span>
            <input
              className="field-input"
              type="email"
              required
              value={form.email}
              onChange={(e) => updateField('email', e.target.value)}
            />
          </div>

          <div className="field-group">
            <span className="field-label">Password</span>
            <input
              className="field-input"
              type="password"
              required
              minLength={8}
              value={form.password}
              onChange={(e) => updateField('password', e.target.value)}
            />
          </div>

          <div className="field-group">
            <span className="field-label">Company Name</span>
            <input
              className="field-input"
              required
              value={form.company_name}
              onChange={(e) => updateField('company_name', e.target.value)}
            />
          </div>

          <div className="field-row">
            <div className="field-group">
              <span className="field-label">Phone (optional)</span>
              <input
                className="field-input"
                value={form.phone}
                onChange={(e) => updateField('phone', e.target.value)}
              />
            </div>
            <div className="field-group">
              <span className="field-label">GSTIN (optional)</span>
              <input
                className="field-input"
                value={form.gstin}
                onChange={(e) => updateField('gstin', e.target.value.toUpperCase())}
              />
            </div>
          </div>

          {/* Unticked by default and required. A pre-ticked box is not
              consent, and the links open in a new tab so a half-filled form
              is not lost when someone actually reads them. */}
          <label className="signup-legal-check">
            <input
              type="checkbox"
              checked={acceptedLegal}
              onChange={(e) => setAcceptedLegal(e.target.checked)}
            />
            <span>
              I have read and agree to the{' '}
              <a href="/terms" target="_blank" rel="noreferrer">Terms of Service</a>, the{' '}
              <a href="/privacy" target="_blank" rel="noreferrer">Privacy Policy</a> and the{' '}
              <a href="/disclaimer" target="_blank" rel="noreferrer">Disclaimer</a>.
              I understand Krosifin does not file returns or make payments, and that dates
              and figures it shows must be verified before I rely on them.
            </span>
          </label>

          <div className="dash-btn-row">
            <button
              className="dash-btn dash-btn-orange"
              type="submit"
              disabled={submitting || !acceptedLegal}
            >
              {submitting ? 'Creating account...' : 'Create Account'}
            </button>
          </div>
        </form>

        <p className="setup-subtitle" style={{ marginTop: 16 }}>
          Already have an account?{' '}
          <button type="button" className="setup-link-btn" onClick={onBackToLogin}>
            Sign in
          </button>
        </p>
      </div>
    </div>
  );
}

export default Signup;
